module.exports = __webpack_public_path__ + "img/ic-icon.44893e53.svg";